export const handleAdminLogout = () => {
  localStorage.removeItem("USER");
  localStorage.removeItem("access-token");
  localStorage.removeItem("currency");

  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};
